import axios from './axios';

interface Coordinates {
  latitude: number;
  longitude: number;
}

export interface Country {
  name: string;
  code: string;
  coordinates: Coordinates;
}

export interface City {
  name: string;
  countryCode: string;
  stateCode: string;
  coordinates: Coordinates;
}

export interface District {
  name: string;
  countryCode: string;
  stateCode: string;
  coordinates: Coordinates;
}

class LocationService {
  private baseUrl = '/locations';

  async getCountries(): Promise<Country[]> {
    const response = await axios.get(`${this.baseUrl}/countries`);
    return response.data.data;
  }

  async getCities(countryCode: string): Promise<City[]> {
    const response = await axios.get(`${this.baseUrl}/cities/${countryCode}`);
    return response.data.data;
  }

  async getDistricts(countryCode: string, stateCode: string): Promise<District[]> {
    const response = await axios.get(`${this.baseUrl}/districts/${countryCode}/${stateCode}`);
    return response.data.data;
  }
}

export const locationService = new LocationService();
